import { render, staticRenderFns } from "./ExamExerciseAnalysis.vue?vue&type=template&id=496a7c6a&scoped=true&"
import script from "./ExamExerciseAnalysis.vue?vue&type=script&lang=js&"
export * from "./ExamExerciseAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./ExamExerciseAnalysis.vue?vue&type=style&index=0&id=496a7c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496a7c6a",
  null
  
)

export default component.exports